import React from "react";

export function WaiveEscrowIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38.86 48.56"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <path
        className="cls-1"
        d="m31.65,48.56H3.15c-1.74,0-3.15-1.41-3.15-3.15V3.15C0,1.41,1.41,0,3.15,0h32.56c1.74,0,3.15,1.41,3.15,3.15v38.19c0,3.98-3.24,7.21-7.21,7.21ZM3.15,1.41c-.96,0-1.74.78-1.74,1.74v42.25c0,.96.78,1.74,1.74,1.74h28.5c3.2,0,5.8-2.6,5.8-5.8V3.15c0-.96-.78-1.74-1.74-1.74H3.15Z"
      />
      <rect className="cls-1" x="6.36" y="7.07" width="26.15" height="5.65" />
      <circle className="cls-1" cx="10.77" cy="19.74" r="2.78" />
      <circle className="cls-1" cx="19.43" cy="19.74" r="2.78" />
      <circle className="cls-1" cx="28.09" cy="19.74" r="2.78" />
      <circle className="cls-1" cx="10.77" cy="29.02" r="2.78" />
      <circle className="cls-1" cx="19.43" cy="29.02" r="2.78" />
      <circle className="cls-1" cx="28.09" cy="29.02" r="2.78" />
      <circle className="cls-1" cx="10.77" cy="38.3" r="2.78" />
      <circle className="cls-1" cx="19.43" cy="38.3" r="2.78" />
      <circle className="cls-1" cx="28.09" cy="38.3" r="2.78" />
      <rect
        className="cls-1"
        x="25.31"
        y="26.24"
        width="5.57"
        height="14.85"
        rx="1.96"
        ry="1.96"
      />
    </svg>
  );
}
